import React, { useState, useEffect } from 'react';
import { socket } from './socket';
import { ConnectionState } from './ConnectionState';
import { ConnectionManager } from './ConnectionManager';

import { useDispatch } from 'react-redux';
import { uiActions } from '../store/ui-slice';
import parsePinStates from './parsePinStates';
import { redirect, useNavigate } from 'react-router-dom';
import { Bounce, toast } from 'react-toastify';

export default function useSocketManager() {

  const [reconnectAttempts, setReconnectAttempts] = useState(0);

  const [isConnected, setIsConnected] = useState(socket.connected);
  const dispatch = useDispatch();

  function onConnect() {
    setIsConnected(true);
    toast.dismiss();
    toast.success('Connection restored!', {
      toastId: 'connected',
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    });

    // dispatch(
    //   uiActions.renderNotification({
    //     status: 'successful',
    //     title: "Socket Connected",
    //   })
    // );
  }

  function onDisconnect() {
    setIsConnected(false);
    toast.dismiss();
    toast.error('We’re having trouble reaching the server. Retrying...', {
      toastId: 'disconnected',
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    });
    // dispatch(
    //   uiActions.renderNotification({
    //     status: 'error',
    //     title: "Socket Disconnected",
    //   })
    // );
  }


  function onConnectionError(err) {
    toast.dismiss();
    toast.warn('Attempting to restore connection...', {
      toastId: 'attemptingConnection',
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    });
    // dispatch(
    //   uiActions.renderNotification({
    //     status: 'error',
    //     title: "Connection error",
    //     message: "Attempting to reconnect...",
    //   })
    // );
  }

  useEffect(() => {
    socket.emit("app")
    //listners
    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);
    socket.on("connect_error", (err) => onConnectionError(err));

    return () => {
      socket.on('connect', onConnect);
      socket.on('disconnect', onDisconnect);
      socket.on("connect_error", onConnectionError);
    };

  }, [socket])

  return isConnected;
}


